// Side-effect register the `form.draft` view with the global CardRegistry.
// Imported from App.tsx like `generative-ui/core` and `generative-ui/sdr`.

import { registerCardComponent } from "@/components/generative-ui/envelope";

import { FormDraftCardView } from "./FormDraftCard";

registerCardComponent("form.draft", FormDraftCardView);

export { FormDraftCardView };
